import { Component, OnDestroy, OnInit } from "@angular/core";
import { Router } from "@angular/router";

type AnnouncementPhase = "pre-maintenance" | "during-maintenance";

@Component({
    selector: "app-background-default-layout",
    templateUrl: "./background-default-layout.component.html",
    styleUrls: ["./background-default-layout.component.css"],
    standalone: false
})
export class BackgroundDefaultLayoutComponent implements OnInit, OnDestroy {
  private static readonly MAINTENANCE_START = new Date("2026-10-01T00:00:00+06:00");
  private static readonly MAINTENANCE_END = new Date("2026-10-01T00:30:00+06:00");

  showAnnouncementSection = false;
  announcementPhase: AnnouncementPhase = "pre-maintenance";
  countdownHours = "00";
  countdownMinutes = "00";
  countdownSeconds = "00";

  private timerInterval: ReturnType<typeof setInterval> | null = null;

  constructor(private router: Router) {}

  ngOnInit(): void {
    this.updateAnnouncement();
    this.timerInterval = setInterval(() => this.updateAnnouncement(), 1000);
  }

  ngOnDestroy(): void {
    if (this.timerInterval) {
      clearInterval(this.timerInterval);
    }
  }

  private updateAnnouncement(): void {
    const now = new Date();

    if (now >= BackgroundDefaultLayoutComponent.MAINTENANCE_END) {
      this.showAnnouncementSection = false;
      return;
    }

    this.showAnnouncementSection = true;

    if (now >= BackgroundDefaultLayoutComponent.MAINTENANCE_START) {
      this.announcementPhase = "during-maintenance";
      this.setCountdown(BackgroundDefaultLayoutComponent.MAINTENANCE_END, now);
    } else {
      this.announcementPhase = "pre-maintenance";
      this.setCountdown(BackgroundDefaultLayoutComponent.MAINTENANCE_START, now);
    }
  }

  private setCountdown(target: Date, now: Date): void {
    const diff = Math.max(0, target.getTime() - now.getTime());
    const hours = Math.floor(diff / 3600000);
    const minutes = Math.floor((diff % 3600000) / 60000);
    const seconds = Math.floor((diff % 60000) / 1000);

    this.countdownHours = hours.toString().padStart(2, "0");
    this.countdownMinutes = minutes.toString().padStart(2, "0");
    this.countdownSeconds = seconds.toString().padStart(2, "0");
  }

  navigateToLandingPage(): void {
    this.router.navigate(["/landing-page"]);
  }
}
